import { lazy, Suspense } from "react";
import { RouteObject } from "../../../../../app/javascript/helpers/tixxt-router";
import Loading from "../../../../../app/javascript/components/shared/Loading";

const AenderungsmeldungPage = lazy(() => import("./Root"));
const MembershipsUserbar = lazy(
  () =>
    import(
      "../../../../../app/javascript/components/memberships/Userbar"
    ),
);

export const dbwvRoutes: RouteObject[] = [
  {
    path: "/custom/dbwv/mitgliedschaft/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <AenderungsmeldungPage />
      </Suspense>
    ),
  },
];

export const dbwvUserbarRoutes: RouteObject[] = [
  {
    path: "/custom/dbwv/mitgliedschaft/edit",
    element: <MembershipsUserbar />,
  },
];

export default dbwvRoutes;
